export type GeoLayerCode =
  | 'wildlife'
  | 'alpguarddog'
  | 'municipalities'
  | 'cantons'
  | 'shooting';

export type GeoBodId =
  | 'ch.bafu.wrz-wildruhezonen_portal'
  | 'ch.bafu.wrz-jagdbanngebiete_select'
  | 'ch.bafu.alpweiden-herdenschutzhunde'
  | 'ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill'
  | 'ch.swisstopo.swissboundaries3d-kanton-flaeche.fill'
  | 'ch.vbs.schiessanzeigen';

export const GEO_CODE_TO_REQUEST_LAYER: Record<GeoLayerCode, string> = {
  wildlife:
    'ch.bafu.wrz-wildruhezonen_portal,ch.bafu.wrz-jagdbanngebiete_select',
  alpguarddog: 'ch.bafu.alpweiden-herdenschutzhunde',
  municipalities: 'ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill',
  cantons: 'ch.swisstopo.swissboundaries3d-kanton-flaeche.fill',
  shooting: 'ch.vbs.schiessanzeigen',
};

export const GEO_BODID_TO_CODE: Record<GeoBodId, GeoLayerCode> = {
  'ch.bafu.wrz-wildruhezonen_portal': 'wildlife',
  'ch.bafu.wrz-jagdbanngebiete_select': 'wildlife',
  'ch.bafu.alpweiden-herdenschutzhunde': 'alpguarddog',
  'ch.swisstopo.swissboundaries3d-gemeinde-flaeche.fill': 'municipalities',
  'ch.swisstopo.swissboundaries3d-kanton-flaeche.fill': 'cantons',
  'ch.vbs.schiessanzeigen': 'shooting',
};
